// @/services/content/store/modules/carbon-accounting-distribution-drawer.js
export class CarbonAccountingDistributionDrawerHandler {
  constructor(store) {
    this.store = store;
  }

  /**
   * Get Carbon Accounting Distribution Drawer content by locale
   * @param {string} locale Locale to get content for
   * @returns {Object|null} Content or null if not found
   */
  getContent(locale = 'en') {
    // Try requested locale first
    const localeContent = this.store.state.data.carbonAccountingDistributionDrawer?.[locale];
    if (localeContent) return localeContent;
    
    // Fall back to English if different locale was requested
    if (locale !== 'en') {
      return this.store.state.data.carbonAccountingDistributionDrawer?.['en'] || null;
    }
    
    return null;
  }
}
